import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {setErrorAction} from "../store/reducers/commonSlice";
import {AuthService} from "../services/AuthService";
import endpoints from "../endpoints";
import IPage from "../types/page";

interface IAddRequest {
    id: number
    url: string
    title: string
    email: string
    skip: boolean
    revision?: number
    status?: number
}

interface IGetAllRequest {
    sort: string
    order: 'desc' | 'asc'
    email: string
}

export const pageAPI = createApi({
    reducerPath: 'pageAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: `${endpoints.api}/pages`,
        prepareHeaders: (headers: Headers) => {
            const token = AuthService.getToken() || ''
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
        }
    }),
    tagTypes: ['pages'],
    endpoints: (builder) => ({
        getAll: builder.query<IPage[], IGetAllRequest>({
            query: (sortingData) => {
                return {
                    url: '',
                    method: 'GET',
                    params: sortingData
                }
            },
            providesTags: ['pages']
        }),
        getAllEmails: builder.query<string[], void>({
            query: () => {
                return {
                    url: '/emails',
                    method: 'GET'
                }
            },
            providesTags: ['pages']
        }),
        add: builder.mutation<void, IAddRequest>({
            query: (pageData) => {
                return {
                    url: '',
                    method: 'POST',
                    body: pageData
                }
            },
            async onQueryStarted(id, {dispatch, queryFulfilled}) {
                try {
                    const {data: result, meta} = await queryFulfilled

                } catch(e: any) {
                    if (e.error?.status === 401) {
                        window.location.href = '/login'
                    } else {
                        dispatch(setErrorAction(e.error?.data?.message || 'Page creation error'))
                    }
                }
            },
            invalidatesTags: ['pages']
        }),
        remove: builder.mutation<void, number>({
            query: (pageId) => {
                return {
                    url: `/${pageId}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: ['pages']
        }),
    })
})